// extracted by mini-css-extract-plugin
module.exports = {"galleryContainer":"Gallery_galleryContainer__2a58F","footerBackground":"Gallery_footerBackground__2h3rK","gallery":"Gallery_gallery__aQN2d"};